<template>
  <v-app>
    <v-content>
      <Synthesis/>
    </v-content>
  </v-app>
</template>

<script>
import Synthesis from './components/Synthesis'

export default {
  name: 'App',
  components: {
    Synthesis
  },
  data: () => ({
    //
  })
}
</script>

<style lang="scss">  
  @media (max-width: 600px) {
    .radio {
      .v-label {
        font-size: 14px;
      }
    }
  }
</style>
